export default __webpack_public_path__ + "static/media/nifa-color-lockup.30b2f193.svg";